import type { RefObject } from "react";

import { cn } from "@synthesis/shared-utils";

import { PAGE_BADGE_SIZE_PX, PREVIEW_HEIGHT_PX, PREVIEW_WIDTH_PX, SIDEBAR_WIDTH_PX, type PagePreview } from "./modal-open-pdf.lib";

type PdfPreviewSidebarProps = {
  sidebarRef: RefObject<HTMLDivElement | null>;
  pagePreviews: PagePreview[];
  isLoadingPreviews: boolean;
  activeIndex: number;
  onSelectPage: (index: number) => void;
};

const PreviewSkeleton = () => <div className="bg-grey-300/30 h-full w-full animate-pulse" />;

const PdfPreviewSidebar = ({ sidebarRef, pagePreviews, isLoadingPreviews, activeIndex, onSelectPage }: PdfPreviewSidebarProps) => (
  <div
    ref={sidebarRef}
    className="bg-neutrals-95 flex h-full flex-col items-center justify-start gap-2 overflow-y-auto px-3 py-4"
    style={{ width: SIDEBAR_WIDTH_PX }}
  >
    {isLoadingPreviews && pagePreviews.length === 0 ? (
      <div className="border-neutrals-90 shrink-0 overflow-hidden rounded border-2" style={{ height: PREVIEW_HEIGHT_PX, width: PREVIEW_WIDTH_PX }}>
        <PreviewSkeleton />
      </div>
    ) : (
      pagePreviews.map((item, index) => (
        <div
          key={item.page}
          className={cn(
            "bg-neutrals-99 relative shrink-0 cursor-pointer overflow-hidden rounded border-2",
            index === activeIndex ? "border-tertiary-80" : "border-neutrals-90",
          )}
          style={{ height: PREVIEW_HEIGHT_PX, width: PREVIEW_WIDTH_PX }}
          onClick={() => onSelectPage(index)}
        >
          <span
            className="bg-neutrals-95 absolute left-1 top-1 z-10 flex items-center justify-center border-2 bg-white text-xs"
            style={{ width: PAGE_BADGE_SIZE_PX, height: PAGE_BADGE_SIZE_PX }}
          >
            {item.page}
          </span>
          {item.img ? <img alt="IMG preview" src={item.img} className="h-full w-full object-contain" /> : <PreviewSkeleton />}
        </div>
      ))
    )}
  </div>
);

export default PdfPreviewSidebar;
